import { RouteRecordRaw } from "vue-router";

export default [
  {
    path: "/isvProductUserListPage",
    name: "isvProductUserListPage",
    meta: { title: "出品人管理" },
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../../../views/ContentPage/ISVAbout/_otherPages/ISVProductUserManage/index.vue"
        )
  },
  { // 分账
    path: "/isvSplitAccountsListPage",
    name: "isvSplitAccountsListPage",
    meta: { title: "分账管理" },
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../../../views/ContentPage/ISVAbout/_otherPages/ISVSplitAccountManage/index.vue"
        )
  }
] as Array<RouteRecordRaw>;
